import MaterialBespoke from "./MaterialBespoke.js";
import { Vector3 } from "three";

if (!AFRAME.components["custommaterial"]) {
  AFRAME.registerComponent("custommaterial", {
    schema: {},
    material: null,
    init: function() {
      // Load
      this.modelloaded = AFRAME.utils.bind(this.modelloaded, this);
      this.el.addEventListener("model-loaded", this.modelloaded);

      this.bespokeMaterial = new MaterialBespoke();

      // Store references
      this.CAMERA = document.querySelector("#camera");

      this.LIGHT_SCENE = document.querySelector("#light_scene");

      this.LAMP = document.querySelector("#lamp");

      const POSITION_LIGHT_LAMP = document
        .querySelector("#light_lamp")
        .getAttribute("position");

      this.OFFSET_LAMP_LIGHT = new Vector3(
        POSITION_LIGHT_LAMP.x * 0.002,
        POSITION_LIGHT_LAMP.y * 0.002,
        POSITION_LIGHT_LAMP.z * 0.002
      );

      // this.LIGHT_LAMP = document.querySelector("#light_lamp");
    },
    update: function() {},
    traverseForMeshes: function(object) {
      var meshes = [];
      if (object.children) {
        if (object.children.length > 0) {
          for (var i = 0; i < object.children.length; i++) {
            meshes = meshes.concat(this.traverseForMeshes(object.children[i]));
          }
        }
      }
      if (object.geometry) {
        meshes.push(object);
      }
      return meshes;
    },
    tick: function() {
      // Sofa
      const POSITION_SOFA = this.el.getAttribute("position");

      // Camera
      const POSITION_CAMERA = this.CAMERA.object3D.children[1].position;

      this.bespokeMaterial.updateCameraPosition(
        new Vector3(
          POSITION_CAMERA.x - POSITION_SOFA.x,
          POSITION_CAMERA.y - POSITION_SOFA.y,
          POSITION_CAMERA.z - POSITION_SOFA.z
        )
      );

      // Lights
      const POSITION_LIGHT_SCENE = this.LIGHT_SCENE.getAttribute("position");
      const POSITION_LAMP = this.LAMP.getAttribute("position");

      this.bespokeMaterial.updateDirectionalLightDirections(
        new Vector3(
          POSITION_LIGHT_SCENE.x - POSITION_SOFA.x,
          POSITION_LIGHT_SCENE.y - POSITION_SOFA.y,
          POSITION_LIGHT_SCENE.z - POSITION_SOFA.z
        ).normalize(),

        new Vector3(
          POSITION_LAMP.x + this.OFFSET_LAMP_LIGHT.x - POSITION_SOFA.x,
          POSITION_LAMP.y + this.OFFSET_LAMP_LIGHT.y - POSITION_SOFA.y,
          POSITION_LAMP.z + this.OFFSET_LAMP_LIGHT.z - POSITION_SOFA.z
        ).normalize()
      );
    },
    modelloaded: function() {
      var meshes = this.traverseForMeshes(this.el.object3D);
      for (var i = 0; i < meshes.length; i++) {
        // Apply material to fabric elements
        if (meshes[i].name == "Aurora_2-Seater-FABRICS") {
          meshes[i].material = this.bespokeMaterial.MATERIAL;
        }
      }
    }
  });
}
